// eslint-disable-next-line prettier/prettier, no-restricted-imports
import { Box, styled } from '@mui/material'
import Colors from 'figma/panda/Colors'

export const BorderContainer = styled(Box)({
  padding: 24,
  border: `1px solid ${Colors.base300}`,
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  flexBasis: 'content',
  maxWidth: 400,
})
